import React, { useState } from "react";

function MstBerger(){
    const [isOpen, setIsOpen] = useState(true);
    function menuStatus(){
        var menuPanel = document.getElementById('menuCollapseset');
        setIsOpen (!isOpen);
        menuPanel.classList.toggle("open");
    }
    
    return (
        <>
            <div className="mst-berger">
                    {
                        <button onClick={menuStatus} class="btn btn-link bd-search-docs-toggle d-lg-none p-0 ml-3 collapsed" type="button" data-toggle="collapse" data-target="#bd-docs-nav" aria-controls="bd-docs-nav" aria-expanded="false" aria-label="Toggle docs navigation">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="27" height="27" focusable="false">
                                <title>Menu</title>
                                <path stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
                            </svg>
                        </button>
                    }
            </div>
        </>
    )
}

export default MstBerger;